import React from 'react';

import { flagStyles } from '../settings';

const SvgMW = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3696px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMW;
